<app-state-view [promise]="activityDetailPromise">
  <loading-state [template]="loading"></loading-state>
  <empty-state [template]="primaryPlaceholder"></empty-state>
  <error-state [template]="error"></error-state>
  <content-state class="places-info-window__content">
    <div class="places-info-window__container">
      <div class="places-info-window__left">
        <img class="places-info-window__img" *ngIf="photoUrl" [src]="photoUrl" width="100" height="100" maxlength="100">
      </div>
      <div class="places-info-window__middle">
        <div class="places-info-window__header">
          <div class="places-info-window__business-name">{{activity.name}}</div>
          <div class="places-info-window__business-link">
            <a *ngIf="activityDetail" [href]="activityDetail.website"
               class="places-info-window__activity-link" target="_blank">
              <mat-icon class="places-info-window__external-link" fontSet="fa" fontIcon="fa-external-link"></mat-icon>
            </a>
          </div>
        </div>
        <div *ngIf="activityDetail" class="places-info-window__rating">
          <star-rating
            [starType]="'svg'"
            [rating]="activityDetail.rating"
            [step]="0.1"
            [showHalfStars]="true"
            [staticColor]='"ok"'
            [size]='"small"'
            [readOnly]="true">
          </star-rating>
        </div>
        <div class="places-info-window__info">
        <p *ngIf="activityDetail">
          Address: {{activityDetail.formatted_address}}<br />
          Phone: {{activityDetail.formatted_phone_number}}
        </p>
        </div>
        <a *ngIf="activityDetail" class="places-info-window__view-large" target="_blank"
           [href]="activityDetail.url">
          Open Google details
        </a>
      </div>
    </div>
  </content-state>
</app-state-view>
<ng-template #primaryPlaceholder>
  {{activity.name}}
  Placeholder
</ng-template>
<ng-template #loading>
  {{activity.name}}
  <mat-spinner [diameter]="16" class="local-activities__spinner"></mat-spinner>
</ng-template>
<ng-template #error>
  <mat-icon class="local-activities__placeholder-icon">warning</mat-icon>
  An error occurred loading activities information for this airport.  Please try back later.
</ng-template>
